
<template>
  <modal
    :visible="value"
    @onClosed="doClose"
    size="xsmall"
  >
    <span slot="head">{{ $t(141) }}</span>
    <div slot="body">
        <div class="lang-item cursor" :class="{active:curColor==='colorMode1'}" @click="switchCurrency('colorMode1')">
            {{$t(148)}}
        </div>
        <div class="lang-item cursor" :class="{active:curColor==='colorMode2'}" @click="switchCurrency('colorMode2')">
            {{$t(149)}}
        </div>
    </div>
  </modal>
</template>
<script>
import Modal from '@/components/Modal'
import { updateValuation } from '@/api'
import utils from '@/utils/misc'
export default {
  name: 'ColorSetting',
  components: {Modal},
  props: {
    value: Boolean
  },

  data() {
    return {
        curColor: 'colorMode1',
    }
  },
  computed: {
  },
  beforeMount() {
    this.curColor = utils.getLs('colorMode')
  },
  methods: {
    switchCurrency(mode) {
      this.curColor = mode
      utils.setLs('colorMode', mode)
    },
    doClose() {
      this.$emit('input', false)
    }
  }
}
</script>
<style lang="scss" scoped>
    .lang-item{
        display: inline-block;
        margin-top: 16px;
        margin-right: 16px;
        width: calc(50% - 16px);
        height: 40px;
        line-height: 40px;
        padding: 0px 12px;
        &:hover{
            border-radius: 4px;
            background-color: #f5f5f5;
        }
        &.active{
            color: $primaryColor;
        }
    }
</style>